import {BaseDTO} from "../_baseDTO.interface";

export interface TermsTemplateDTO extends BaseDTO {
  customerId?: string;
  description?: string;
  name?: string;
}
